import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function LegalPage() {
  return (
    <div className="min-h-screen bg-background py-8 px-4">
      <div className="max-w-2xl mx-auto">
        <Button asChild variant="ghost" className="mb-4"><Link to="/"><ChevronLeft className="h-4 w-4 mr-1" />Volver</Link></Button>
        <h1 className="text-3xl font-heading mb-6">Aviso Legal</h1>
        <div className="prose prose-sm max-w-none space-y-4 text-muted-foreground">
          <h2 className="text-lg font-medium text-foreground">1. Datos identificativos</h2>
          <p>En cumplimiento del articulo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Informacion y Comercio Electronico (LSSICE), se informa al usuario de los datos del titular de esta web.</p>
          <p>El titular de este sitio web se reserva el derecho de modificar el presente Aviso Legal en cualquier momento.</p>

          <h2 className="text-lg font-medium text-foreground">2. Objeto</h2>
          <p>Esta pagina web tiene como finalidad ofrecer informacion sobre los servicios de peluqueria y permitir la reserva de citas online.</p>

          <h2 className="text-lg font-medium text-foreground">3. Propiedad intelectual</h2>
          <p>Todos los contenidos de este sitio web, incluyendo textos, fotografias, graficos, imagenes, iconos, tecnologia, software, asi como su diseno y codigos fuente, constituyen una obra cuya propiedad pertenece al titular, sin que puedan entenderse cedidos al usuario ninguno de los derechos de explotacion reconocidos por la normativa vigente en materia de propiedad intelectual.</p>

          <h2 className="text-lg font-medium text-foreground">4. Exclusion de responsabilidad</h2>
          <p>El titular no se hace responsable de los perjuicios que pudieran ocasionarse por el uso inadecuado de esta web. Asimismo, queda exonerado de toda responsabilidad derivada de la informacion publicada en su sitio web cuando haya sido manipulada o introducida por un tercero ajeno.</p>

          <h2 className="text-lg font-medium text-foreground">5. Legislacion aplicable</h2>
          <p>Para la resolucion de todas las controversias o cuestiones relacionadas con el presente sitio web, sera de aplicacion la legislacion espanola.</p>
        </div>
      </div>
    </div>
  );
}
